export default __webpack_public_path__ + "static/media/prudential.19812aea.svg";